import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementWebformTermsOfService'],
  (item, ctx) => {
    const { $texts } = useEasyTexts()

    const text = $texts(
      'webform.termsOfServiceLabel',
      'Ich bestätige hiermit die @terms gelesen und verstanden zu haben.',
    )
    const terms = $texts('webform.termsOfServiceLink', 'Nutzungsbedingungen')

    const matches = /(.+)@terms(.+)/gm.exec(text) || []

    return {
      $formkit: 'checkbox',
      sectionsSchema: {
        label: {
          children: [
            matches[1] || '',
            {
              $el: 'a',
              attrs: {
                href: ctx.global.termsOfServiceUrl,
                class: 'underline',
                target: '_blank',
              },
              children: terms,
            },
            matches[2] || '',
          ],
        },
      },
    }
  },
)
